export default __webpack_public_path__ + "static/media/payment-congrates.a82a5bbf.png";